
import React from "react";
import { TrendingUp, ShieldCheck, Zap } from "lucide-react";

// Constants for stats
const STATS = [
  {
    icon: TrendingUp,
    value: "77%",
    label: "Directors who rank AI among their TOP‑3 strategic risks (McKinsey, 2024)",
  },
  {
    icon: ShieldCheck,
    value: "24%",
    label: "Directors who feel very prepared to oversee AI today (Stanford CGRI, 2023)",
  },
  {
    icon: Zap,
    value: "$25k+",
    label: "Consulting value of templates & toolkits INCLUDED with Blueprint enrollment",
  },
];

// Helper component
const StatCard = ({ icon: Icon, value, label }) => (
  <div className="flex flex-col items-center text-center p-4 rounded-2xl shadow-md bg-white/80 backdrop-blur">
    <Icon className="w-8 h-8 mb-2 text-techne-purple" />
    <span className="text-3xl font-semibold">{value}</span>
    <p className="text-sm mt-1 max-w-xs">{label}</p>
  </div>
);

const BlueprintStats: React.FC = () => {
  return (
    <section className="mb-16">
      <h2 className="text-3xl font-bold text-center mb-10">Why AI Governance Matters</h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {STATS.map((stat, i) => (
          <StatCard key={i} icon={stat.icon} value={stat.value} label={stat.label} />
        ))}
      </div>
    </section>
  );
};

export default BlueprintStats;
